module.exports = __webpack_public_path__ + "img/profile-icon.18dac257.svg";